import accountsReducer from './accountsReducer';

export default accountsReducer;
